import loadable from 'components/dynamic-import';

export { useCreateFeed } from './components/create-feed';

const PublicFeedPage = loadable(() => import('./PublicFeedPage'));
const PublicFeedDetailPage = loadable(() => import('./PublicFeedDetailPage'));
const ConnectedPublicFeed = loadable(() => import('./ConnectedPublicFeed'));

export { ConnectedPublicFeed, PublicFeedPage, PublicFeedDetailPage };
